import arcNav from './arc-nav/arcNav';
import arcNavConfig from './arc-nav/arcNavConfig';
import twpTranslate from './twp-translate/twpTranslate';
import hoverActionBox from './hover-action-box/hoverActionBox';
import breadcrumbs from './breadcrumbs';
import panels from './panels/panels';
import refineSearchTerm from './refine-search-term/refineSearchTerm';
import fillRemainingHeight from './fill-remaining-height/fillRemainingHeight';
import refineDirection from './refine-direction/refineDirection';
import numericSpinner from './numeric-spinner/numericSpinner';
import clickTracker from './click-tracker/clickTracker';
import listSelectorDialog from './list-selector-dialog/listSelectorDialog';
import loadSpinner from './load-spinner/loadSpinner';
import keyStats from './key-stats/keyStats';
import pitchBar from './pitch-bar/pitchBar';
import pitchDatePicker from './pitch-date-picker/pitchDatePicker';
import platformList from './platform-list/platformList';
import platformPitch from './platform-pitch/platformPitch';
import pitchInfo from './pitch-info/pitchInfo';
import pitchForm from './pitch-form/pitchForm';
import publicationPitch from './publication-pitch/publicationPitch';
import plainText from './plain-text/plainText';
import twpDateQuickPick from './date-quickpick/twpDateQuickpick';
import dateQuickPicker from './date-quickpick/dateQuickPicker';
import disabledComponentMask from './disabled-component-mask/disabledComponentMask';
import ngEnter from './ng-enter/ngEnter';
import twpToggleSwitch from './twp-toggle-switch/twpToggleSwitch';
import stopPropagation from './stop-propagation/stopPropagation';
import publishStatusName from './publish-status-name/publishStatusName';
import pageTitle from './page-title/pageTitle';
import checkboxFilter from './checkbox-filter/checkboxFilter';
import checkboxFilterMultiLevel from './checkbox-filter-multi-level/checkboxFilterMultiLevel';
import checkboxOption from './checkbox-option/checkboxOption';
import searchPubs from './search-pubs/searchPubs';
import pitchPanel from './pitch-panel/pitchPanel';
import pitchBadge from './pitch-panel/pitchBadge';
import collectionsModal from './pitch-panel/collectionsModal';
import refreshButton from './refresh-button/refreshButton';
import groupTypeahead from './group-typeahead/groupTypeahead';
import updateStyle from './update-style/updateStyle';
import upcomingEditionsSelector from './upcoming-editions-selector/upcomingEditionsSelector';
import peopleTypeahead from './people-typeahead/peopleTypeahead';
import multisitePlansCollectionToggle from './multisite-plans-collection-toggle/multisitePlansCollectionToggle';
import multisiteSection from './multisite-section/multisiteSection';
import multisiteSectionsList from './multisite-sections-list/multisiteSectionsList';
import multisiteSelector from './multisite-selector/multisiteSelector';
import refineDatePicker from './refine-date-picker/refineDatePicker';
import selectedPitches from './selected-pitches/selectedPitches';
import textCopy from './text-copy/textCopy';
import ngIndeterminate from './ng-indeterminate/ngIndeterminate';

const toLoad = [
  arcNav,
  arcNavConfig,
  twpTranslate,
  hoverActionBox,
  breadcrumbs,
  panels,
  refineSearchTerm,
  fillRemainingHeight,
  numericSpinner,
  refineDirection,
  clickTracker,
  listSelectorDialog,
  loadSpinner,
  keyStats,
  pitchBar,
  pitchDatePicker,
  platformList,
  platformPitch,
  pitchInfo,
  pitchForm,
  publicationPitch,
  plainText,
  twpDateQuickPick,
  dateQuickPicker,
  disabledComponentMask,
  ngEnter,
  twpToggleSwitch,
  stopPropagation,
  publishStatusName,
  pageTitle,
  checkboxFilter,
  checkboxFilterMultiLevel,
  checkboxOption,
  searchPubs,
  pitchPanel,
  pitchBadge,
  collectionsModal,
  refreshButton,
  groupTypeahead,
  updateStyle,
  upcomingEditionsSelector,
  peopleTypeahead,
  multisitePlansCollectionToggle,
  multisiteSection,
  multisiteSectionsList,
  multisiteSelector,
  refineDatePicker,
  selectedPitches,
  textCopy,
  ngIndeterminate
];

export default function (ngModule) {
  toLoad.forEach(fn => fn(ngModule));
}
